import {
  STORE_APPLICATION,
} from 'ActionTypes/application';

const initialState = {
  applicationProcessId: '0',
  channel: null,
  customerId: '0',
  productType: null,
};

export const storeApplication = (state = initialState, action) => {
  switch (action.type) {
    case STORE_APPLICATION:
      return {
        applicationProcessId: action.data.applicationId || state.applicationProcessId,
        channel: action.data.channel || state.channel,
        customerId: action.data.customerId || state.customerId,
        customerName: action.data.customerName || state.customerName,
        productType: action.data.productType || state.productType,
      };
    default:
      return { ...state };
  }
};

export default storeApplication;
